import { Avatar } from "@atoms/index"

import styles from "./ImageCell.module.scss"
import { ImageCellProps } from "./ImageCell.types"

function ImageCell(props: ImageCellProps) {
    const { src, fallbackName } = props

    return (
        <div className={styles.base}>
            <Avatar variant="company" size="lg" src={src || undefined} fallbackName={fallbackName} />
        </div>
    )
}

export default ImageCell
